import { computed } from '@vue/composition-api'
import { isNavLinkActive, navLinkProps } from '@core/layouts/utils'

export default function useVerticalNavMenuLink(props) {
  const isActive = computed(() => {
    const item = props.item || {}
    if (item && item.active) return true
    return isNavLinkActive(item)
  })

  const linkProps = navLinkProps(props.item || {})

  const updateIsActive = () => {}

  return {
    isActive,
    linkProps,
    updateIsActive,
  }
}
